<template>
  <div class="goods-list" v-loading="loading">
    <el-row :gutter="30">
      <el-col :span="8" v-for="(item, index) in list" :key="index">
        <div class="goods-item" @click="toDetail(item)">
          <div class="goods-item-image">
            <img :src="item.coverPic" class="imagecover" />
          </div>
          <div class="goods-info">
            <div class="goods-name more-text">{{item.name}}</div>
            <div class="goods-about more-t-2">{{item.description}}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-pagination
      style="text-align: right;"
      background
      layout="prev, pager, next"
      :current-page.sync="page"
      :page-size="size"
      :total="total"
      @current-change="pageChange"
      v-if="total"
    >
    </el-pagination>
    <qrcode-dialog ref="qrcodeDialog" />
  </div>
</template>

<script>
import { loadRestaList } from '@/api/api'
import QrcodeDialog from './QrcodeDialog.vue'
export default {
  components: {
    QrcodeDialog
  },
  data() {
    return {
      list: [],
      page: 1,
      size: 10,
      loading: false,
      total: 0,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    toDetail(item) {
      let url = `https://admin.gdyfpt.com/product/?id=${item.id}&pageType=restaurant&codeType=routine`
      this.$refs.qrcodeDialog.showQrcode(url);
    },
    loadData() {
      var params = Object.assign({
        page: this.page,
        limit: this.size
      }, this.query)
      this.loading = true
      loadRestaList(params).then(res => {
        this.loading = false
        this.total = res.totalElements
        this.list = res.content
      }).catch(err => {
        this.loading = false
      })
    },
    pageChange(val) {
      this.page = val
      this.loadData()
    },
  }
}
</script>

<style scoped lang="scss">
.goods-list {
  padding-top: 20px;
  padding-bottom: 50px;
  .goods-item {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    margin-bottom: 30px;
    .goods-item-image {
      width: 100%;
      height: 240px;
    }
    .goods-info {
      padding: 10px;
      .goods-name {
        width: 100%;
        height: 24px;
        line-height: 24px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-bottom: 8px;
      }
      .goods-about {
        font-size: 13px;
        color: #666666;
        font-family: Microsoft YaHei;
      }
    }
  }
}
</style>